import { Link } from "react-router-dom"
import { IoMailOutline, IoSendOutline } from "react-icons/io5"


export default function Footer1() {
	return (
		<>
			<footer className="footer background-black">
				<div className="footer-widgets">
					<div className="themeflat-container">
						<div className="row footer-top">
							<div className="col-xxl-3 col-lg-3 col-xl-4 col-md-12 logo-footer">
								<div className="widget">
									<div className="textwidget">
										<div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
											<img id="a1" src="/images/predixio-light.svg" alt="logo" style={{ marginBottom: 0, width: '70%', height: 'auto' }} />
										</div>
									</div>
									<div className="textwidget">
										<span>Football Match Prediction Engine</span>
									</div>
								</div>
							</div>
							<div className="col-xxl-5 col-lg-5 col-xl-4 col-md-6 link-footer">
								<div className="widget widget_menu-footer">
									<h5 className="widget-title">Predixio</h5>
									<ul className="menu-footer">
										<li><Link to="/">Home</Link></li>
										<li><Link to="/predictions">Football Predictions</Link></li>
										<li><Link to="/tips">Betting Tips</Link></li>
									</ul>
								</div>
								<div className="widget widget_menu-footer">
									<h5 className="widget-title">Account</h5>
									<ul className="menu-footer">
										<li><Link to="/login">Sign in</Link></li>
										<li><Link to="/register">Sign up</Link></li>
										<li><Link to="/account">My Account</Link></li>
									</ul>
								</div>
								<div className="widget widget_menu-footer">
									<h5 className="widget-title">Resources</h5>
									<ul className="menu-footer">
										<li><Link to="/faq">FAQ</Link></li>
										<li><Link to="/support">Support</Link></li>
										<li><Link to="/contact">Contact</Link></li>
									</ul>
								</div>
							</div>
							<div className="col-xxl-4 col-lg-4 col-xl-4 col-md-6 new-letter">
								<div className="widget widget_text">
									<h5 className="widget-title">Newsletter</h5>
									<form>
										<div className="input-new-letter">
											<input className="btn-email" name="email" id="emails" type="email" placeholder="Your email address" required />
											<button className="btn-submit" type="submit"><IoSendOutline fontSize={22} style={{ color: "#fff" }} /></button>
										</div>
									</form>
									<p style={{ marginTop: 10 }}><IoMailOutline /> info@predixio.co</p>
								</div>
							</div>
						</div>
						<div className="row footer-bottom">
							<div className="col-md-6 col-sm-12">
								<div className="copyright">
									<p>©2025 <Link to="/" target="_blank"> Predixio.</Link> All rights reserved.
									</p>
								</div>
							</div>
							<div className="col-md-6 col-sm-12">
								<ul className="link-footer-bottom">
									<li><Link to="/terms">Terms of services</Link></li>
									<li><Link to="/privacy">Privacy policy</Link></li>
									<li><Link to="/cookies">Cookie policy</Link></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</>
	)
}
